<template>
  <div class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">Developer Badges</h1>
      <p class="hero-subtitle">
        Provide recognition for achievements and behaviour in your organisation by awarding badges to your employees.
      </p>
    </div>
    <div class="hero-divider"></div>
    <div class="hero-actions">
      <router-link to='/badges'>
        <button type="button" class="btn btn-primary-action w-100">
          View my badges
        </button>
      </router-link>
      <router-link to='/badges/award'>
        <button type="button" class="btn btn-outline-light w-100">
          Award badges to employees
        </button>
      </router-link>
    </div>
  </div>

  <div class="md my-3">
    <div class="section-inner">
      <h2>About</h2>
      <div class="section-line"></div>
      <p class="mt-2">
        Badges are not monetary, nor do they make someone better than someone else.
        The only intention of the badges is to provide permanent and visible recognition for <i>exceptional</i> performance, next to the usual monetary rewards or a promotion.
      </p>
      <p>
        Check out this blog post for a <a href="https://www.vangemert.dev/blog/badges-for-software-developers">list of available badges</a>.
        Why would your company need this?
        Read my blog post about "<a href="https://www.vangemert.dev/blog/the-motivation-paradox">The motivation paradox</a>."
      </p>
    </div>
    <div class="section-line"></div>
    <div class="section-inner">
      <h2>Example</h2>
      <span class="my-2 mb-3 text-center email-title">
        <span class="mono-text">name@example.com</span>
      </span>
      <div class="demo-badge-row">
        <span class="icon">{{demo_badge.icon}}</span>
        <div class="demo-badge-info">
          <span class="badge-title">{{demo_badge.title}}</span>
          <span class="badge-desc">{{demo_badge.description}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { badges } from '@/badges/badges.js'

  export default {
    data() {
      return {
        demo_badge: badges[Math.floor(Math.random() * badges.length)],
        interval: setInterval(() => {
          this.new_badge()
        }, 3000)
      }
    },
    created () {
      document.title = "Developer Badges"
    },
    methods: {
      new_badge() {
        this.demo_badge = badges[Math.floor(Math.random() * badges.length)]
      }
    },
    unmounted() {
      clearInterval(this.interval);
    }
  }
</script>

<style scoped>
  .hero-section {
    text-align: left;
    padding: 48px 0 32px;
  }
  .hero-content {
    margin-bottom: 24px;
  }
  .hero-title {
    font-family: "Inter", sans-serif;
    font-size: 36px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: #fff;
    margin-bottom: 12px;
  }
  .hero-subtitle {
    font-size: 16px;
    color: var(--text-secondary);
    max-width: 560px;
    line-height: 1.6;
  }
  .hero-divider {
    height: 1px;
    background: var(--border-default);
    margin-bottom: 24px;
  }
  .hero-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .btn-primary-action {
    background-color: var(--accent) !important;
    color: #000 !important;
    border: none !important;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    padding: 10px 20px;
    border-radius: var(--radius-sm);
    transition: background-color 0.15s ease;
  }
  .btn-primary-action:hover {
    background-color: var(--accent-hover) !important;
  }

  .section-inner {
    padding: 20px 24px;
  }
  .section-line {
    height: 1px;
    background: var(--border-default);
  }

  .mono-text {
    font-family: "Roboto Mono", monospace;
    color: var(--text-secondary);
  }

  .email-title {
    font-size: 18px;
    word-break: break-all;
    display: block;
    margin-bottom: 16px;
  }

  .demo-badge-row {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 16px;
    border: 1px solid var(--border-default);
    border-radius: var(--radius-sm);
    background: var(--bg-surface-raised);
    margin-bottom: 8px;
  }

  .icon {
    font-size: 52px;
    flex-shrink: 0;
  }

  .demo-badge-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .badge-title {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: var(--text-primary);
  }

  .badge-desc {
    font-size: 14px;
    color: var(--text-secondary);
  }
</style>